<template>
  <el-dialog
    append-to-body
    width="600px"
    title="名片信息"
    :visible.sync="visible"
    :before-close="reset"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
  >
    <el-descriptions
      title="工单信息"
      :column="2"
      border
      style="margin-top: 20px"
    >
      <el-descriptions-item label="选择工人">{{
        dataInfo.order.name
      }}</el-descriptions-item>
      <el-descriptions-item label="性别">{{
        dataInfo.order.sex === 1 ? "男" : "女"
      }}</el-descriptions-item>
      <el-descriptions-item label="联系电话">{{
        dataInfo.order.phone
      }}</el-descriptions-item>
      <!-- 平台专享价时显示接单时间 -->
      <el-descriptions-item
        label="接单时间"
        v-if="dataInfo && dataInfo.job && dataInfo.job.price_type == 3"
        >{{ dataInfo.order.choose_time }}</el-descriptions-item
      >
      <template v-else>
        <el-descriptions-item label="报名时间">{{
          dataInfo.order.apply_time
        }}</el-descriptions-item>
        <el-descriptions-item label="选择时间">{{
          dataInfo.order.choose_time
        }}</el-descriptions-item>
        <el-descriptions-item label="工单金额"
          >¥{{ dataInfo.order.total_amount }}</el-descriptions-item
        >
      </template>
      <el-descriptions-item label="经纪人收益"
        >¥{{ dataInfo.order.agency_amount }}（{{
          dataInfo.order.agency_rate
        }}%）</el-descriptions-item
      >
      <!-- <el-descriptions-item label="平台收益">¥{{earnings}}（{{100 - Number(dataInfo.order.agency_rate) - Number(dataInfo.order.woker_rate)}}%）</el-descriptions-item> -->
      <el-descriptions-item label="师傅收益"
        >¥{{ dataInfo.order.woker_amount }}（{{
          dataInfo.order.woker_rate
        }}%）</el-descriptions-item
      >
      <el-descriptions-item label="平台收益"
        >¥{{ dataInfo.order.platform_amount }}（{{
          dataInfo.order.platform_rate
        }}%）</el-descriptions-item
      >
      <!-- <el-descriptions-item label="服务类型">{{dataInfo.order.service_type === 1 ? '包工包料' : '包工不包料'}}</el-descriptions-item> -->
      <!-- <el-descriptions-item label="预付金额">¥{{dataInfo.order.prepay_amount}}</el-descriptions-item> -->
      <!-- <el-descriptions-item label="尾款金额">¥ {{dataInfo.order.total_amount - dataInfo.order.prepay_amount}}</el-descriptions-item> -->
      <!-- 状态不是待确认时都展示确认时间 -->
      <!-- <template v-if="dataInfo.order.status !== 1">
          <el-descriptions-item label="确认时间">{{dataInfo.order.check_time}}</el-descriptions-item>
        </template> -->
      <!-- 待完工 -->
      <template v-if="dataInfo.order.status === 3">
        <el-descriptions-item label="开工时间">{{
          dataInfo.order.work_time || ""
        }}</el-descriptions-item>
      </template>
      <!-- 待结算 -->
      <template v-if="dataInfo.order.status === 4">
        <el-descriptions-item label="开工时间">{{
          dataInfo.order.work_time || ""
        }}</el-descriptions-item>
        <el-descriptions-item label="完工时间">{{
          dataInfo.order.verify_time
        }}</el-descriptions-item>
      </template>
      <!-- 已完成 -->
      <template v-if="dataInfo.order.status === 5">
        <el-descriptions-item label="开工时间">{{
          dataInfo.order.work_time || ""
        }}</el-descriptions-item>
        <el-descriptions-item label="完成时间">{{
          dataInfo.order.complete_time
        }}</el-descriptions-item>
        <!-- <el-descriptions-item label="结算时间">{{dataInfo.order.settlement_time}}</el-descriptions-item> -->
      </template>
      <!-- 申请取消中/或申请退款中 -->
      <template
        v-if="dataInfo.order.cancel_type > 0 && dataInfo.order.status > 4"
      >
        <el-descriptions-item label="申请取消时间">{{
          dataInfo.order.apply_cancel_time
        }}</el-descriptions-item>
      </template>
      <!-- 师傅已取消 -->
      <template
        v-if="dataInfo.order.cancel_type > 0 && dataInfo.order.status < 4"
      >
        <el-descriptions-item label="申请取消时间">{{
          dataInfo.order.apply_cancel_time
        }}</el-descriptions-item>
        <el-descriptions-item label="对方同意时间">{{
          dataInfo.order.cancel_time
        }}</el-descriptions-item>
      </template>
      <el-descriptions-item label="付款时间">{{
        dataInfo.order.pay_time || ""
      }}</el-descriptions-item>
      <el-descriptions-item label="状态">
        <!-- <span>{{
          dataInfo.order.cancel_type
            ? dataInfo.order.status > 4
              ? cancel[dataInfo.order.cancel_type]
              : applyCancel[dataInfo.order.cancel_type]
            : status[dataInfo.order.status]
        }}</span> -->
        <span>{{getStatusLabel(dataInfo.order)}}</span>
      </el-descriptions-item>
    </el-descriptions>
    <template #footer>
      <el-row type="flex" justify="center">
        <el-button @click="toggle(false)">关闭</el-button>
      </el-row>
    </template>
  </el-dialog>
</template>

<script>
export default {
  data() {
    return {
      status: {
        0:'待确认',
        1:'待确认',
        2:'待开工',
        3:'待完工',
        4:'待结算',
        5:'已完成',
        6:'已取消',
        8:'完工待确认',
      },
      applyCancel: {
        1: "申请退款",
        2: "申请取消",
      },
      cancel: {
        1: "老板已经取消",
        2: "师傅已经取消",
      },
      visible: false,
      loading: false,
      labelStyle: { width: "160px" },
      info: {},
      dataInfo: {
        order: {},
        job: {},
      },
      certPreviewVisible: false,
      certPreviewUrl: "",
    };
  },
  methods: {
    getStatusLabel(row) {
      if(row.cancel_type) {
        if(row.status > 4){
          return this.cancel[row.cancel_type]
        }else {
          return this.applyCancel[row.cancel_type]
        }
      }else {
        return this.status[row.status]
      }
    },
    previewCert(url) {
      this.certPreviewUrl = url;
      this.certPreviewVisible = true;
    },
    // 获取详情
    getDetail(row) {
      this.info = row;
      this.init();
    },
    init() {
      this.$http
        .get("/admin/flex_order/info", { params: { id: this.info.order_id } })
        .then((res) => {
          if (res.code == 1) {
            this.dataInfo = res.data;
          }
        });
    },
    reset(done) {
      this.dataInfo = {
        order: {},
      };
      done && done();
    },
    toggle(show) {
      this.visible = show;
      !show && this.reset();
    },
  },
};
</script>
<style lang="scss">
.cert-preview-dialog .el-dialog__header {
  padding: 10px 20px;
}
.cert-preview-dialog .el-dialog__body {
  padding: 10px 20px 20px;
}
</style>
<style lang="scss" scoped>
.cert-preview-outer {
  text-align: center;
}
.cert-preview-wrap {
  position: relative;
  display: inline-block;
  .cert-preview-img {
    max-width: 100%;
    max-height: 600px;
    display: block;
  }
  .cert-watermark {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    overflow: hidden;
    pointer-events: none;
    user-select: none;
    transform: rotate(-30deg);
    display: flex;
    flex-direction: column;
    justify-content: space-around;
    .wm-row {
      display: flex;
      justify-content: space-around;
      .wm-cell {
        color: rgba(204, 204, 204, 1);
        font-size: 16px;
        font-weight: bold;
        letter-spacing: 2px;
        white-space: nowrap;
      }
    }
  }
}
</style>
